import produce from 'immer';

import { CHECK_QR_CODE_ERROR, CHECK_QR_CODE_SUCCEED } from './QRCode.constants';

export const initialState = {
  errorMessage: '',
  qrcode: null,
};

/* eslint-disable default-case, no-param-reassign, no-unused-vars */
const StampReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case CHECK_QR_CODE_SUCCEED: {
        draft.qrcode = action.payload.result;
        draft.errorMessage = '';
        break;
      }
      case CHECK_QR_CODE_ERROR: {
        draft.errorMessage = action.errorMessage;
        break;
      }
    }
  });

export default StampReducer;
